import { CalendarOff, Clock } from "lucide-react";
import { useHoursStatus } from "@/lib/hours";
import { cn } from "@/lib/utils";

const STYLES = {
  open: "border-primary/40 bg-accent text-primary",
  closed: "border-border bg-muted text-muted-foreground",
  holiday: "border-amber-400 bg-amber-50 text-amber-700",
};

export const HoursBadge = () => {
  const s = useHoursStatus();
  if (!s) return null;
  const Icon = s.state === "holiday" ? CalendarOff : Clock;
  return (
    <div
      data-testid="hours-badge"
      data-state={s.state}
      className={cn("mt-3 inline-flex max-w-full items-start gap-2 rounded-md border px-2.5 py-1.5 text-xs", STYLES[s.state])}
    >
      <span className="relative mt-1 flex h-2 w-2 shrink-0">
        {s.state === "open" && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-60" />}
        <span className={cn("relative inline-flex h-2 w-2 rounded-full", s.state === "open" ? "bg-primary" : s.state === "holiday" ? "bg-amber-500" : "bg-muted-foreground")} />
      </span>
      <span className="min-w-0">
        <span className="font-semibold flex items-center gap-1" data-testid="hours-badge-label">
          <Icon className="h-3 w-3" /> {s.label}
        </span>
        {s.note && <span className="block truncate" data-testid="hours-badge-note">{s.note}</span>}
        {s.sub && <span className="block opacity-90" data-testid="hours-badge-sub">{s.sub}</span>}
      </span>
    </div>
  );
};
